<template>
  <div class="main" style="margin-top:20px">
    <vue-loading
      v-show="spinLoading" style="fill: #1890ff;width: 50px;height: 50px;position: fixed;z-index: 99999;top: 50%;left: 50%;margin-top: -50px;margin-left: -50px;" type="bars"
      color="#096dd9"
    >
    </vue-loading>
    <div v-show="spinLoading" style="position: fixed;z-index: 99999;top: 50%;left: 50%;margin-top: 7px;margin-left: -60px;color:#096dd9;font-size:15px;font-weight:600;">
      正在加载...
    </div>
    <div class="maTop">
      <div class="main_top">
        <img class="main_topImg" src="http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210809/16284796436719612335581674f508fc4fb126a97d570.png">
        <span class="lable_name">运营小区总数 </span>
        <span class="lable_num">{{ deliveryData.housingEstate }}个</span>
      </div>
      <div class="main_top">
        <img class="main_topImg" src="http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210809/1628479706707fec75b7312b74476bea58214d084fdc1.png">
        <span class="lable_name">运营点位总数</span>
        <span class="lable_num">{{ deliveryData.product }}个</span>
      </div>
      <div class="main_top">
        <img class="main_topImg" src="http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210809/162847974036588923b1f721e478ab83eb8cdec8ddbe4.png">
        <span class="lable_name">运营人员总数</span>
        <span class="lable_num">{{ deliveryData.operatingUserCount }}个</span>
      </div>
    </div>
    <div class="secher">
        <a-auto-complete
        ref="autocomplete"
        v-if="blurs"
        v-model="state"
        style="width: 200px"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入小区名称查询"
        :popper-append-to-body="false"
        popper-class="select-popper"
        @select="handleSelect"
        @blur="blurss"
        >
        <a-button v-if="state === ''" style="width:57px"><template #icon><SearchOutlined /></template></a-button>
        <a-button v-else slot="append" type="primary" style="width:57px" @click="handle(state)">
          <template #icon><SearchOutlined /></template>
        </a-button>
        </a-auto-complete>
   <el-autocomplete
        v-if="blurs"
        v-model="state"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入小区名称查询"
        :popper-append-to-body="false"
        popper-class="select-popper"
        @select="handleSelect"
        @blur="blurss"
      >
        <el-button
          v-if="state === ''"
          slot="append" type="primary" style="width:57px"
        >
        </el-button>
        <el-button
          v-else
          slot="append" type="primary" style="width:57px"
          @click="handle(state)"
        >
        </el-button>
      </el-autocomplete> 
        <!-- <a-auto-complete  v-else
        ref="autocomplete"
        v-model="state"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入小区名称查询"
        :popper-append-to-body="false"
        popper-class="select-popper"
        @select="handleSelect"
        @blur="blurss"
        >
        <a-button v-if="state === ''" style="width:57px"><template #icon><SearchOutlined  /></template></a-button>
        <a-button v-else slot="append" type="primary" style="width:57px" @click="handle(state)"><template #icon><SearchOutlined  /></template>
        </a-button>
        </a-auto-complete> -->
       <el-autocomplete
        ref="autocomplete"
        v-model="state"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入小区名称查询"
        :popper-append-to-body="false"
        popper-class="select-popper"
        @select="handleSelect"
        @blur="blurss"
      >
        <el-button
          v-if="state === ''"
          slot="append" type="primary" style="width:57px"
        >
        </el-button>
        <el-button
          v-else
          slot="append" type="primary" style="width:57px"
          @click="handle(state)"
        >
        </el-button>
      </el-autocomplete> 
      <div v-if="state === ''" style="position: absolute;right: 19px;top: 10px;cursor:pointer;">
        <IconFont
          class="iconsousuo"
          type="iconsousuo"
          style="font-size: 18px; "
        />
      </div>
      <div v-else style="position: absolute;right: 19px;top: 10px;cursor:pointer;" @click="handle(state)">
        <IconFont
          class="iconsousuo"
          type="iconsousuo"
          style="font-size: 18px; "
        />
      </div>
      <!-- <a-input-search
        placeholder="input search text" enter-button
        @search="onSearch" @focus="asd"
      /> -->
    </div>
    <div id="allmap" @click="allmaps"></div>
    <div>
      <div class="foot_top" @click="showDrawer">
        <a-icon type="double-left" style="transform: rotate(90deg);" />
        <span style="padding-left: 15px; font-size: 16px;">展开查看排名</span>
      </div>
      <div>
        <a-drawer
          class="drawer"
          height="428"
          :closable="false"
          placement="bottom"
          :visible="visible"
          :after-visible-change="afterVisibleChange"
          @close="onClose"
        >
          <template slot="title">
            <div style="cursor: pointer;" @click="onClose">
              <a-icon type="double-left" style="transform: rotate(-90deg);" />
              <span style="padding-left: 15px;">收起排名</span>
            </div>
          </template>

          <div
            class="myChart1_title" style="position: absolute;left: 100px;    top: 60px;align-items: center;"
          >
            <div style=" border-bottom: solid 2px;#0078FD;border-color: #0078FD;">
              <img src="http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210809/16284753345833a95f15c12c940358be02772664b920d.png">
              <span style="color: #0A0A0A;font-size:18px">街道最新排名</span>
            </div>
            <div style="margin-right:45px;z-index:9;cursor: pointer;" @click="streetList">
              <img src="http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210809/162847593209824eef14941974640a92761cac0dcf7c1.png">
              <span style="color: #666666;padding-left:5px">查看更多</span>
            </div>
          </div>
          <div style="    position: absolute;left: 111px;    top: 120px;color: #666666;">
            单位: 分
          </div>
          <div id="myChart1" style="width:33%;height:350px;padding-top: 30px;" class="myChart">
            <!-- <div>这是第一和认同</div> -->
          </div>
          <div
            class="myChart1_title" style="position: absolute;left: 38%;    top: 60px;align-items: center;"
          >
            <div style=" border-bottom: solid 2px;#0078FD;border-color: #0078FD;">
              <img style="width:30px;height:30px" src="http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210903/163064932427801e03d0b6dbd409fb0823a50ad437a03.png">
              <span style="color: #0A0A0A;font-size:18px">小区最新排名</span>
            </div>
            <div style="margin-right:99px;z-index:9;cursor: pointer;" @click="estateList">
              <img src="http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210809/162847593209824eef14941974640a92761cac0dcf7c1.png">
              <span style="color: #666666;padding-left:5px">查看更多</span>
            </div>
          </div>
          <div id="eaches" style="width:33%;height:350px;border-right: 1px solid #D8D8D8;border-left: 1px solid #D8D8D8;" class="myChart"></div>
          <div
            class="myChart1_title" style="position: absolute;left: 67%;    top: 60px;align-items: center;"
          >
            <div style=" border-bottom: solid 2px;#0078FD;border-color: #0078FD;">
              <img style="width:30px;height:30px" src="http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210903/1630649378982ac3420b8209c48c7a5371901fc4e1895.png">
              <span style="color: #0A0A0A;font-size:18px">运营人员最新排名</span>
            </div>
            <div style="margin-right:65px;z-index:9;cursor: pointer;" @click="personList">
              <img src="http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210809/162847593209824eef14941974640a92761cac0dcf7c1.png">
              <span style="color: #666666;padding-left:5px">查看更多</span>
            </div>
          </div>
          <div id="eachei" style="width:33%;height:350px;" class="myChart"></div>
        </a-drawer>
      </div>
    </div>
    <!-- <div class="modules">
      <div class="middle">
        <div class="footer">
          middle
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>

// import { getRegionByProduct } from '@/api/operation'
// import Vue from 'vue'
import $ from 'jquery'
import Vue from 'vue'
import * as echarts from 'echarts'
// import { iconFontComponent, gdEncrypt } from '@/components/mixins/mixins.js'
import { getEstateSousing, getStreetRanking } from '@/api/assess'
import { getRegionByProduct, getDetailedCount, getAreaList, getHousingEstateList } from '@/api/operation'
import { VueLoading } from 'vue-loading-template'
import { getLvRank } from '@/api/workBench'
import { input, autocomplete, button } from 'element-ui'

Vue.use(input).use(autocomplete).use(button)
export default {
  components: { VueLoading },
  // mixins: [iconFontComponent, gdEncrypt],

  data () {
    return {
      infoWindow: '',
      areaList: [],
      map: null,
      visible: false, // 抽屉
      deliveryData: {},
      xAxisDatas: [], // 街道
      seriesDatas: [],
      xAxisData: [],
      seriesData: [],
      xAxisData1: [],
      seriesData1: [],
      maxValue: 0,
      streeList: [],
      names: ['第一名', '第二名', '第三名'],
      spinLoading: false,
      list: {},
      pointList: {
        la: '',
        lo: ''
      },
      shows: false,
      item: '',
      replica: '',
      listNum: {},
      clerList: [],
      restaurants: [],
      state: '',
      timeout: null,
      blurs: false
    }
  },
  created () {
    this.$forceUpdate()
    // 字符串模板添加点击事件
    window.btns = this.btns
    window.asd = this.asd
    window.pointOperations = this.pointOperations
  },

  mounted () {
    this.getData('4').then(res => {
      this.showMap(res)
    })
    getAreaList().then(res => {
      const result = res.result || []
      Vue.ls.set('areasList', result)
    })
    this.getDetailedCount()
    this.getEstateRanking()
    this.getLvRank()
    this.getAssessList()
    this.onSearch()
    // this.getStreetDeatil()
  },
  methods: {
    allmaps () {
      this.$refs.autocomplete.suggestions = []
    },
    blurss () {
      if (this.blurs) {
        console.log('true')
      }
    },
    handles () {},
    onSearch () {
      const params = {
        housingEstate: this.state
      }
      getHousingEstateList(params).then(res => {
        this.clerList = res.result
        this.restaurants = res.result
      })
    },
    querySearchAsync (queryString, cb) {
      const params = {
        housingEstate: this.state
      }
      this.listNum = {}
      getHousingEstateList(params).then(res => {
        // this.restaurants = res.result

        // this.listNum = res
        // const restaurants = this.restaurants
        var results = queryString ? res.result : ''
        if (results) {
          this.restaurants = results.map((res) => {
            this.listNum = res
            return {
              value: res.estateName,
              la: res.la,
              lo: res.lo,
              id: res.estateId
            }
          })
          clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {
            cb(this.restaurants)
          }, 100 * Math.random())
        } else {
          if (this.state === '') {
            const restaurants = res.result.map((res) => {
              // console.log(res, 222)
              return {
                value: res.estateName,
                la: res.la,
                lo: res.lo,
                id: res.estateId
              }
            })
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
              cb(restaurants)
            }, 100 * Math.random())
          } else {
            const restaurants = this.restaurants.map((res) => {
              // console.log(res, 333)
              return {
                value: res.estateName,
                la: res.la,
                lo: res.lo,
                id: res.estateId
              }
            })
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
              cb(restaurants)
            }, 100 * Math.random())
          }
        }
      })
    },
    handleSelect (item) {
      console.log(item, 'handleSelect')
      this.$router.push({ path: '/operationsManaments/pointOperations/list', query: { zoom: 18, ids: item.id }})
      // console.log(item, 'itemitemitemitemitemitemitemitem')
      // this.pointList.la = item.la
      // this.pointList.lo = item.lo
      // this.item = item.value
    },
    // 运营
    handle (val) {
      if (this.listNum && this.listNum.estateId) {
        this.$router.push({ path: '/operationsManagement/pointOperations', query: { zoom: 18, ids: this.listNum.estateId }})
      } else {
        this.$message.error('暂时没有该小区')
      }
    },
    getDetailedCount () {
      getDetailedCount().then(res => {
        this.deliveryData = res.result
      })
    },
    // 小区 图表排行
    getAssessList () {
      const params = {
        page: 1,
        pageSize: 5
      }
      getEstateSousing(params).then(res => {
        const arr = res.result
        // console.log(arr, '这是小区')
        const villArr = []
        const arr1 = []
        const arr2 = []
        arr.map(item => {
          // this.getStreetDeatil(item.streetId)
          arr1.push(item.estateName)
          arr2.push(item.score)
          return
        })
        villArr.push(arr1, arr2)

        this.xAxisDatas = villArr[0]

        this.seriesDatas = villArr[1]
      })
    },

    // 街道图表排名图
    getEstateRanking () {
      const params = {
        page: 1,
        pageSize: 5
      }
      getStreetRanking(params).then(res => {
        const arr = res.result
        // console.log(arr, '这是街道')
        const villArr = []
        const arr1 = []
        const arr2 = []
        arr.map(item => {
          arr1.push(item.streetName)
          arr2.push(item.score)
          return
        })
        villArr.push(arr1, arr2)
        this.xAxisData = villArr[0]
        this.seriesData = villArr[1]
      })
    },
    // 运营人员等级排行
    getLvRank () {
      const params = {
        page: 1,
        pageSize: 8
      }
      getLvRank(params).then(res => {
        const arr = res.result
        arr.length = 8
        const arr1 = []
        const arr2 = []
        arr.map(item => {
          arr1.unshift(item.userName)
          arr2.unshift(item.lvExp)
          return
        })
        this.xAxisData1 = arr1
        this.seriesData1 = arr2

        this.maxValue = this.seriesData1[this.seriesData1.length - 1]
        // console.log(, 'this.seriesData1')
      })
    },

    showDrawer () {
      this.visible = true
      console.log(this.visible,'哈哈哈')
      setTimeout(() => {
        this.eache()
        this.eaches()
        this.eachei()
      }, 500)
    },
    afterVisibleChange (val) {

    },
    onClose () {
      this.visible = false
    },
    // 以上抽屉展开
    //  街道排名
    eache () {
      const chartDom = document.getElementById('myChart1')
      const myChart = echarts.init(chartDom)
      const option = {
        xAxis: {
          type: 'category',
          data: this.xAxisData,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value'
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [{
          data: this.seriesData,
          type: 'bar',
          barWidth: '16',

          itemStyle: {
            normal: {
              label: {
                show: true, // 开启限时
                position: 'top', // 在上方显示
                textStyle: {
                  color: '#0179FD',
                  fontSize: 16
                }

              },
              color: function (params) {
                if (params.name === '钱钱') {
                  return new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                    offset: 0,
                    color: '#FCBF55' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: '#FD8E5C' // 100% 处的颜色
                  }], false)
                } else {
                  return new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                    offset: 0,
                    color: '#89CBFC' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: '#0078FD' // 100% 处的颜色
                  }], false)
                }
              }

            }
          }
        }]
      }
      myChart.setOption(option)
      setTimeout(function () {
        window.addEventListener('resize', function () {
          myChart.resize()
        })
      }, 200)
    },
    // 小区排名
    eaches () {
      const chartDom = document.getElementById('eaches')
      const myChart = echarts.init(chartDom)
      const pathSymbols = {

        reindeer1: 'image://http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210807/16283298392039e6f05c96e4f43068e0e405da93e83de.png',
        reindeer2: 'image://http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210807/16283299548987f803e8c9553474194ac03f7d8a239f9.png',
        reindeer3: 'image://http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210807/1628329980282d5bd6a8d81f0455b8d572340c374f55a.png'
      }

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          },
          formatter: function (params) {
            return params[0].name + ': ' + params[0].value
          }
        },
        grid: {
          // height: 250

        },
        xAxis: [
          {

            data: this.xAxisDatas,
            axisTick: { show: false },
            axisLine: { show: false },

            axisLabel: {
              interval: 0
              // rotate: 80    清楚文字间隙    倾斜度
            }
          }
        ],

        yAxis: {
          splitLine: { show: false },
          axisTick: { show: false },
          axisLine: { show: false },
          axisLabel: { show: false }
        },
        series: [{
          // barWidth: '150%',
          // name: 'hill',
          type: 'pictorialBar',
          barCategoryGap: '-100%',
          symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
          itemStyle: {
            opacity: 0.5,
            normal: {
              label: {
                show: false
              },
              color: function (params) {
                if (params.name === '钱钱') {
                  return new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                    offset: 0,
                    color: '#0A7EFD' // 0% 处的颜色
                  }, {
                    offset: 1,
                    // opacity: 0.6,
                    color: 'rgba(135, 202, 252, 0.6)' // 100% 处的颜色
                  }], false)
                } else {
                  return new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                    offset: 0,
                    color: 'rgba(135, 202, 252, 0.6)' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: '#0A7EFD' // 100% 处的颜色
                  }], false)
                }
              }
            }
          },
          emphasis: {
            itemStyle: {
              opacity: 1
            }
          },
          data: this.seriesDatas,
          z: 10
        }, {
          name: 'glyph',
          type: 'pictorialBar',
          barGap: '-100%',
          symbolPosition: 'end',
          symbolSize: 20,
          symbolPadding: 20,
          symbolOffset: [0, '-120%'],
          data: [{
            value: this.seriesDatas[0],
            symbol: pathSymbols.reindeer1,
            symbolSize: [30, 30]
          }, {
            value: this.seriesDatas[1],
            symbol: pathSymbols.reindeer2,
            symbolSize: [30, 30]
          }, {
            value: this.seriesDatas[2],
            symbol: pathSymbols.reindeer3,
            symbolSize: [30, 30]
          }]
        }]
      }
      myChart.setOption(option)
      setTimeout(function () {
        window.addEventListener('resize', function () {
          myChart.resize()
        })
      }, 200)
    },
    // 运营人员排名
    eachei () {
      const vm = this
      const chartDom = document.getElementById('eachei')

      const myChart = echarts.init(chartDom)
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // type: 'shadow'
            type: 'none'
          }
        },
        grid: {
          left: '0%',
          right: '10%',
          bottom: '5%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          show: false
          // splitLine: {
          //   show: false
          // }
        },
        axisLine: { show: false }, // 隐藏x轴线
        yAxis: {
          type: 'category',
          // show: false,
          data: vm.xAxisData1,

          axisTick: {
            show: false
          },
          // 去除基准线
          axisLine: {
            show: false
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#e1e1e1'
            }
          }
        },

        series: [{

          data: vm.seriesData1,
          type: 'bar',
          showBackground: true,
          barCategoryGap: '50',
          barWidth: '10',
          itemStyle: {
            normal: {
              label: {
                show: true, // 开启限时
                position: 'top', // 在上方显示
                // right: 'right',
                textStyle: {
                  // align: 'right',
                  fontSize: 12,
                  // color: function (params) {
                  //   console.log(vm.seriesData1, 'params7777')
                  // }
                  color: '#037AFD'

                },
                formatter (params) {
                  if (vm.seriesData1.length - params.dataIndex <= 3) {
                    return `第${(vm.seriesData1.length - params.dataIndex)}名`
                  } else {
                    return ''
                  }
                }

              },
              color: function (params) {
                if (params.value > 0)
                // if(params.)var end = this.seriesData1[seriesData1.length-1]  maxValue
                {
                  if (params.dataIndex === (vm.seriesData1.length) - 1) {
                    return new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                      offset: 0,
                      color: '#FCBF55' // 0% 处的颜色
                    }, {
                      offset: 1,
                      color: '#FD8E5C' // 100% 处的颜色
                    }], false)
                  } else {
                    return new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                      offset: 0,
                      color: '#89CBFC' // 0% 处的颜色
                    }, {
                      offset: 1,
                      color: '#0078FD' // 100% 处的颜色
                    }], false)
                  }
                }
              }

            }
          }
          // data: this.xAxisData1
        },
        {

          // data: [{
          //   value: this.seriesData[0],
          //   symbol: '222',
          //   symbolSize: [30, 30]
          // }, {
          //   value: this.seriesData[1],
          //   symbol: ' pathSymbols.reindeer2',
          //   symbolSize: [30, 30]
          // }, {
          //   value: this.seriesData[2],
          //   symbol: 'pathSymbols.reindeer3',
          //   symbolSize: [30, 30]
          // }]

        }
        ]
      }
      myChart.setOption(option)
      setTimeout(function () {
        window.addEventListener('resize', function () {
          myChart.resize()
        })
      }, 200)
    },
    // 以上是图表
    getData (type) {
      return new Promise(resolve => {
        const params = {
          type: type
        }
        this.spinLoading = true
        getRegionByProduct(params).then(res => {
          const result = res.result
          this.areaList = result
          this.spinLoading = false
          resolve(result)
        })
      })
    },
    // 地图
    showMap (res) {
      const vm = this
      vm.$gaoMap().then(AMap => {
        const map = new AMap.Map('allmap', {
          zoom: 13,
          // zooms: [3, 19], // 设置地图级别范围
          // center: [116.43, 39.92],
          // resizeEnable: true,
          resizeEnable: true,
          viewMode: '3D',
          pitch: 45,
          showIndoorMap: false, // 关闭室内地图
          mapStyle: 'amap://styles/grey'
          // rotateEnable: true
          // mapStyle: 'amap://styles/60d1a67a637f006b35ef1e200876190d'
        }) // 创建Map实例

        vm.map = map
        const initPoint = res
        const initObj = initPoint[0] // 默认取第一个街道信息，默认显示第一个街道点位。
        let initPointObj = null
        for (const key in initObj) {
          initPointObj = initObj[key]
        }
        // console.log(initPointObj, 'initPointObj')
        getAreaList().then(res => {
          const result = res.result || []
          Vue.ls.set('areasList', result)
        })
        const areaList = Vue.ls.get('areasList') // 当前账号管理的区域
        // console.log(areaList[0], '8520')
        if (areaList.length === 0 || areaList[0].cityName) {
          vm.map.setZoomAndCenter(13, [initPointObj.longitude, initPointObj.latitude])
        }

        areaList[0] && areaList[0].cityName && vm.map.setZoomAndCenter(14, [initPointObj.longitude, initPointObj.latitude])
        // 监听zoonm
        vm.map.on('complete', function () {
          // 获取
          var ambientLight = map.AmbientLight // 获取环境光
          var directionLight = map.DirectionLight // 获取平行光
          ambientLight.setIntensity(0.9)// 修改强度
        })
        vm.map.on('zoomchange', function () {
          console.log('监听')
          const zoomLevel = vm.map.getZoom()

          if (zoomLevel > 15) { // 如果>15去获取小区的信息
            // vm.map.centerAndZoom(point, 19)
            vm.map.clearMap()
            vm.handleClick()
          }
          else if (zoomLevel <= 15) {
            vm.getData('4').then(res => {
              // vm.map.clearOverlays()
              vm.map.clearMap()
              vm.handleStreet(res, 'street')
            })
          }
        })
      })
    },
    handleStreet (data, flag) {
      // const vm = this

      $.each(data, (index, item) => {
        $.each(item, (index, dataItem) => {
          // var marker = new AMap.Map('allmap', {
          //   resizeEnable: true,
          //   center: [dataItem.longitude, dataItem.latitude],
          //   zoom: 13,
          //   viewMode: '3D',
          //   pitch: 45,
          //   rotateEnable: true
          // })
          // vm.map.setCenter([dataItem.longitude, dataItem.latitude])
          this.$nextTick(function () {
            // console.log(dataItem, '坐标')
            const infoTpl = `
          <div class='aa' >     
            <div class='reference'>${dataItem.name}</div>  
           </div> `
            // ponitIcon  坐标div
            const iconTpl = `
          <div style="width:55px;height:66px">
            <img src="http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210807/16283060424916aa3aa07d6a040c6960d7dbce5a7f683.png" style="width:100%;height:100%"></img>
          </div> `
            //
            const position = new AMap.LngLat(dataItem.longitude, dataItem.latitude)
            var marker = new AMap.Marker({
              position: [dataItem.longitude, dataItem.latitude],
              content: infoTpl
            })
            var markerss = new AMap.Marker({
              position: position,
              content: iconTpl,
              offset: new AMap.Pixel(10, 25) // 设置文本标注偏移量
            })

            // marker.setMap(this.map)
            // vm.map.add(marker)
            // 图标上方街道小区
            // marker.setLabel({
            //   offset: new AMap.Pixel(-5, 115), // 设置文本标注偏移量
            //   content: iconTpl, // 设置文本标注内容
            //   direction: 'top' // 设置文本标注方位
            // })
            // console.log(marker, 'marker')
            // 将 markers 添加到地图
            this.map.add(marker)
            this.map.add(markerss)
            const vm = this
            // marker.setMap(vm.map)
            // point_icon
            // const iconMarker = new AMap.Marker(iconTpl, {
            //   position: [dataItem.longitude, dataItem.latitude],
            //   offset: new AMap.Pixel(-25, -60)

            // })
            // marker.setMap(map)
            // iconMarker.setLabel({
            //   offset: new AMap.Pixel(-30, -80), // 设置文本标注偏移量
            //   content: iconTpl // 设置文本标注内容

            // })

            // point_info
            // const infoMarker = new AMap.Marker(infoTpl, {
            //   position: [dataItem.longitude, dataItem.latitude],
            //   offset: new AMap.Pixel(-50, -105)
            //   // offset: new BMapGL.Size(-50, -105)
            // })
            // infoMarker.setLabel({
            //   offset: new AMap.Pixel(-50, -105), // 设置文本标注偏移量
            //   content: iconTpl // 设置文本标注内容

            // })
            // hove_info
            // const zoomLevel = vm.map.getZoom()
            let info = ''

            // try {
            if (flag === 'street') {
              info = `
          <div class='xiaoqu' style='display:flex;'>
            <div style='width:85px;z-index:-999999'>
            </div>
            <div>
              <div class="infoDialog">
                <div class="cenBody">
                  ${dataItem.name}
                </div>
              <div class="top">
                <span>${dataItem.info[0].categoryName}</span>
                <span class="topSize">${dataItem.info[0].productNum}</span>台
                <span class="topSize">${dataItem.info[0].estateNum}</span>个小区
              </div>
              <div class="cen">
                <span>${dataItem.info[1].categoryName}</span>
                <span class="topSize">${dataItem.info[1].productNum}</span>台
                <span class="topSize">${dataItem.info[1].estateNum}</span>个小区
              </div>
              <div class="bom">
                <span>${dataItem.info[2].categoryName}</span>
                <span class="topSize">${dataItem.info[2].productNum}</span>台
                <span class="topSize">${dataItem.info[2].estateNum}</span>个小区
              </div>
            </div>
          </div>
        `
            }

            // 缩放小区hove
            const infos = `
          <div style='display:flex;'>
            <div style='width:85px;'>
            </div>
            <div>
              <div class="infoDialog">
                <div class="cenBody">
                  ${dataItem.name}
                </div>
              <div class="top">
                <span>街道排名</span>
                <span class="topSize">${dataItem.ranking}</span>名
            
              </div>
              <div class="cen">
                <span>运营人员</span>
                <span class="topSize">${dataItem.userCount}</span>名
               
              </div>
              <div class="bom" @click="dian">
                <span>点位总数</span>
                <span class="topSize">${dataItem.count}</span>个
               
              </div>
             
            </div>
          </div>
        `

            var infoWindow = new AMap.InfoWindow({
              isCustom: true, // 使用自定义窗体
              offset: new AMap.Pixel(240, 20)
            })
            // console.log(marker, 'marker')
            marker.on('mouseover', function (e) {
              if (flag === 'street') {
                infoWindow.setContent(
                  `
          <div class="jiedao" style='display:flex;'>
            <div style='width:85px;'>
            </div>
            <div >
              <div class="infoDialog">
                <div class="cenBody">
                  ${dataItem.name}
                </div>
              <div class="top">
                <span>${dataItem.info[0].categoryName}</span>
                <span class="topSize">${dataItem.info[0].productNum}</span>台
                <span class="topSize">${dataItem.info[0].estateNum}</span>个小区
              </div>
              <div class="cen">
                <span>${dataItem.info[1].categoryName}</span>
                <span class="topSize">${dataItem.info[1].productNum}</span>台
                <span class="topSize">${dataItem.info[1].estateNum}</span>个小区
              </div>
              <div class="bom">
                <span>${dataItem.info[2].categoryName}</span>
                <span class="topSize">${dataItem.info[2].productNum}</span>台
                <span class="topSize">${dataItem.info[2].estateNum}</span>个小区
              </div>
            </div>
          </div>
        `
                )

                infoWindow.open(vm.map, position)
              } else {
                infoWindow.setContent(
                  `
          <div class='xiaoqu' style='display:flex;pointer-events: auto;'>
            <div style='width:85px;'>
            </div>
            <div style='pointer-events: auto;'>
              <div class="infoDialog">
                <div class="cenBody">
                  ${dataItem.name}
                </div>
              <div class="top" >
                <span>街道排名</span>
                <span class="topSize">${dataItem.ranking}</span>名
              </div>
              <div class="cen">
                <span>运营人员</span>
                <span class="topSize">${dataItem.userCount}</span>名
              </div>
              <div class="bom" @click="dian">
                <span>点位总数</span>
                <span class="topSize">${dataItem.count}</span>个
              </div>
             <div class="infos_btn" onclick="pointOperations('${dataItem.id}')"> 
             <span style='font-size: 12px;'>查看详情</span>
              <img style="width:16px;height:16px" src="http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20211019/16346156198342dfe40199bf54be3a9cfddc8f7f0abf6.png">
             </div>
            </div>
          </div>
            `
                )

                infoWindow.open(vm.map, position)
              }
            })

            infoWindow.on('mouseout', function (e) {
              infoWindow.close(vm.map, position)
            })
            marker.on('mouseout', function (e) {
              // infoWindow.close(vm.map, position)
              // if (flag === 'street') {
              //   infoWindow.setContent(
              //     `
              //   <div class="jiedao" style='display:flex;'>
              //     <div style='width:85px;'>
              //     </div>
              //     <div >
              //       <div class="infoDialog">
              //         <div class="cenBody">
              //           ${dataItem.name}
              //         </div>
              //       <div class="top">
              //         <span>${dataItem.info[0].categoryName}</span>
              //         <span class="topSize">${dataItem.info[0].productNum}</span>台
              //         <span class="topSize">${dataItem.info[0].estateNum}</span>个小区
              //       </div>
              //       <div class="cen">
              //         <span>${dataItem.info[1].categoryName}</span>
              //         <span class="topSize">${dataItem.info[1].productNum}</span>台
              //         <span class="topSize">${dataItem.info[1].estateNum}</span>个小区
              //       </div>
              //       <div class="bom">
              //         <span>${dataItem.info[2].categoryName}</span>
              //         <span class="topSize">${dataItem.info[2].productNum}</span>台
              //         <span class="topSize">${dataItem.info[2].estateNum}</span>个小区
              //       </div>
              //     </div>
              //   </div>
              // `
              //   )
              //   infoWindow.open(vm.map, position)
              // } else {
              //   infoWindow.setContent(
              //     `
              //   <div class='xiaoqu' style='display:flex;pointer-events: auto;'>
              //     <div style='width:85px;pointer-events: auto;'>
              //     </div>
              //     <div style='pointer-events: auto;'>
              //       <div class="infoDialog">
              //         <div class="cenBody">
              //           ${dataItem.name}
              //         </div>
              //       <div class="top" >
              //         <span>街道排名</span>
              //         <span class="topSize">${dataItem.ranking}</span>名
              //       </div>
              //       <div class="cen">
              //         <span>运营人员</span>
              //         <span class="topSize">${dataItem.userCount}</span>名
              //       </div>
              //       <div class="bom" @click="dian">
              //         <span>点位总数</span>
              //         <span class="topSize">${dataItem.count}</span>个
              //       </div>
              //      <div class="infos_btn" onclick="pointOperations('${dataItem.id}')">
              //      <span style='font-size: 12px;'>查看详情</span>
              //       <img style="width:16px;height:16px" src="http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20211019/16346156198342dfe40199bf54be3a9cfddc8f7f0abf6.png">
              //      </div>
              //     </div>
              //   </div>
              //     `
              //   )
              //   infoWindow.open(vm.map, position)
              // }

              infoWindow.close(vm.map, position)
            })
            infoWindow.on('click', function (e) {
              console.log('带你文')
              vm.map.setZoomAndCenter(17, [e.lnglat.lng, e.lnglat.lat])
            })
            marker.on('click', function (e) {
              infoWindow.close(vm.map, position)
              vm.map.setZoomAndCenter(17, [e.lnglat.lng, e.lnglat.lat])
            })

            //   marker.on('mouseover', function (e) {
            //     console.log(e)
            //     infoWindow.setContent(
            //       `
            //   <div class="jiedao" style='display:flex;'>
            //     <div style='width:85px;'>
            //     </div>
            //     <div>
            //       <div class="infoDialog">
            //         <div class="cenBody">
            //           ${dataItem.name}
            //         </div>
            //       <div class="top">
            //         <span>${dataItem.info[0].categoryName}</span>
            //         <span class="topSize">${dataItem.info[0].productNum}</span>台
            //         <span class="topSize">${dataItem.info[0].estateNum}</span>个小区
            //       </div>
            //       <div class="cen">
            //         <span>${dataItem.info[1].categoryName}</span>
            //         <span class="topSize">${dataItem.info[1].productNum}</span>台
            //         <span class="topSize">${dataItem.info[1].estateNum}</span>个小区
            //       </div>
            //       <div class="bom">
            //         <span>${dataItem.info[2].categoryName}</span>
            //         <span class="topSize">${dataItem.info[2].productNum}</span>台
            //         <span class="topSize">${dataItem.info[2].estateNum}</span>个小区
            //       </div>
            //     </div>
            //   </div>
            // `
            //     )
            //     console.log('有没有')
            //     // infoMarker.setStyle({
            //     //   background: "url('http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210901/1630484932345d84a178488bb4e25b8ab460e8cefdbc0.png') no-repeat",
            //     //   color: '#fff',
            //     //   backgroundSize: 'contain',
            //     //   border: 'none',
            //     //   zIndex: '99'
            //     // })

            //     // flag === 'street' && infoTemplate.setStyle({
            //     //   'visibility': 'inherit'

            //     // })
            //   })

            // let infoTemplate = ''
            // if (flag === 'street') {
            //   infoTemplate = new AMap.Marker(info, {
            //     position: [dataItem.longitude, dataItem.latitude],
            //     offset: new AMap.Pixel(10, -260)
            //   })
            // }

          // 缩放小区hove
          // const infoTemplates = new AMap.Marker(infos, {
          //   position: [dataItem.longitude, dataItem.latitude],
          //   offset: new AMap.Pixel(10, -260)
          // })
          })
        })
      })
    },
    handleClick () {
      this.getData('5').then(res => {
        this.handleStreet(res, 'plot')
      })
    },
    // 跳转到小区详情
    pointOperations (val) {
      console.log(val, 'val')
      this.$router.push({ path: '/operationsManaments/pointOperations/list', query: { zoom: 18, ids: val }})
    },
    streetList () {
      this.$router.push({ path: '/assessNew/streetList' })
    },
    estateList () {
      this.$router.push({ path: '/assessNew/estateList' })
    },
    personList () {
      this.$router.push({ path: '/assessNew/personList' })
    },
    btns (val) {
      // console.log('ni被点击率额')
      this.$router.push({ path: '/assessNew/estateList' })
    }
  }
}
</script>
<style scoped>
 #allmap {
    /* pointer-events: none ; */
  }
/deep/ .amap-marker {
 pointer-events: block !important;
}
/deep/ .select-popper {
  margin-top: -1px !important;
  left: 0 !important;
}

>>> .el-input-group__append {
    color: #FFFFFF;
    background: #0078FD;
    border: 0;
}
>>> .el-input__inner {
    /* padding-right: 30px; */
    width: 358px;
}
>>> .el-icon-search{
  font-size: 18px;
}
  /* 高德地图 */

>>> .amap-info {
  pointer-events: none;
}

>>> .amap-marker-content {
  pointer-events: block;
}

 >>> .aa {
    width:110px;
    height: 40px;
    line-height: 32px;
    text-align: center;
    color:#0179FD;
    border:none;
    background: url('http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210901/1630478104837d2a9fd9621534336a126f4c214778c86.png') no-repeat;
    background-size: cover;
    /* z-index: 9999 !important */
  }
 >>> .aa:hover {
    width:110px;
    height: 40px;
    line-height: 32px;
    text-align: center;
    color:#0179FD;
    color: #FFFFFF;
    border:none;
   background: url('http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210901/1630484932345d84a178488bb4e25b8ab460e8cefdbc0.png') no-repeat;
    background-size: cover;
    z-index: 99999;

  }
 >>> .amap-marker-label {
    border: none;
   background:none;
  }
 >>> .reference {
    font-size: 14px;
  }
>>> .dataImg {
  margin-top: -28px;
    width: 116px;
    height: 50px;
}
>>> .jiedao {
              width: 372px;
            height: 197px;
            padding: 0;
            border: none;
            background: url('http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210810/16285654348722c4827eefb9c4582aade3de15d199dac.png') no-repeat;
              /* z-index: 99999 !important; */
               pointer-events: none;
}

>>> .xiaoqu {
              width: 372px;
            height: 197px;
            padding: 0;
            border: none;
            background: url('http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210810/16285654348722c4827eefb9c4582aade3de15d199dac.png') no-repeat;
            visibility: 'hidden';
              pointer-events: block;
}
>>> .amap-info-content {
  background: none;
}
>>> .amap-info-outer, .amap-menu-outer {
    background: none;
}
/* 高德地图1.4.15版本 */
/* >>> .amap-marker-content {
  white-space: none !important;
      white-space: inherit;
} */
>>> .amap-marker-content {
  white-space: inherit !important;
}
/* 高德地图 */
</style>
<style >
       .amap-logo{
       display: none;
       opacity:0 !important;
       }
       .amap-copyright {
           opacity:0;
       }
 .close {
    width: 50px;
    height: 50px;
    font-size: 18px;
    color: red;
    /* text-align: right; */
    position: absolute;
    top: 0;
    right: 0;
    margin-right: 20px;
    margin-top: 10px;
    text-align: center;
    cursor: pointer;
}

  .infoDialogCen {
    position: absolute;
    z-index:-1
  }
  .cenBody {
    color: #0179FD;padding-left:26px;padding-top:16px;font-size:16px;font-family: PingFangSC-Semibold, PingFang SC;
  }
  .cenBody::before{
    position: absolute;
    width: 3px;
    height: 14px;
    background: #0179FD;
    content: "";
    margin-left: -9px;
    top: 19px;
}
  .top{
    font-size: 14px;
    margin-top: 15px;
    padding-left: 15px;
  }
  .bom {
    font-size: 14px;    margin-top: 15px;padding-left: 15px;
  }
  .cen {
      font-size: 14px;    margin-top: 15px;padding-left: 15px;
  }
 .infoDialog_btn {
        position: absolute;
    /* right: 0; */
    width: 80px;
    height: 23px;
    background: #FFFFFF;
    box-shadow: 0px 0px 4px 0px #cce0f5;
    border-radius: 2px;
    border: 1px solid #0179FD;
    color: #0179FD;
    text-align: center;
    /* margin-right: 43px; */
    margin-left: 186px;
    margin-top: 14px;
  }
  /* .infoDialog_btn {
    width: 80px;
    height: 23px;
    background: #FFFFFF;
    box-shadow: 0px 0px 4px 0px #CCE0F5;
    border-radius: 2px;
    border: 1px solid #0179FD;
    text-align: center;
    line-height: 23px;
    font-size: 12px;
    color:#0179FD;
    float: right;
    margin-right: 30px;
  } */
  .topSize {
    color: #0179FD;
    width: 30px;
    text-align: right;
    display: inline-block;
  }
  .infos_btn {
    width: 80px;
    height: 24px;
    background: #FFFFFF;
    box-shadow: 0px 0px 4px 0px #CCE0F5;
    border-radius: 2px;
    border: 1px solid #0179FD;
    margin-left: 190px;
    text-align: center;
    color: #0179FD;
    line-height: 21px;
  margin-top: 10px;
      cursor: pointer;
      pointer-events: auto;
  }
    .secher {
    /* width: 415px; */
    height:38px;
    position: absolute;
    top: 10;
   z-index: 99;
    margin-top: 20px;
    margin-left: 38px;
  }
.ant-input-group .ant-input {
    height: 38px;
}
  .ant-btn {
    width: 57px;
    height: 38px;
}
  .maTop {
    position: absolute;
    top: 10;
    right: 0;
    display: flex;
    justify-content: flex-end;
    padding-top: 20px;
    z-index: 99;
    margin-right: 40px;
  }
  .main_top {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 201px;
    height: 52px;
    line-height: 52px;
    text-align: center;
    color: #FFFFFF;
    background: linear-gradient(45deg, #067CFD 0%, #83C6FD 100%);
    box-shadow: 0px 12px 10px -3px rgba(2, 122, 253, 0.5);
    border-radius: 4px;
    margin-left: 20px;
  }
 .lable_name{
    margin-left: 8px;
    margin-right: 13px;
    font-size: 14px;
  }
  .lable_num{
    font-size: 18px;
    font-weight: 500;
  }
  .ant-drawer-title{
    color: #666666 !important;
    text-align: center;
  }
  .BMap_bubble_center img:nth-last-child(2){
    display: none;
  }
.shadow {
    display: none;
  }
 .BMap_bubble_pop {
    padding: 0 !important;
    background: none !important;
    border: none !important;
  }
  .BMap_bubble_top{
    display: none !important;
  }
  .BMap_bubble_pop img:nth-last-child(2) {
    width: 200px !important;
    opacity: 0 !important;
  }
 .BMap_bubble_pop >>> img:nth-child(2) {
    width: 200px !important;
    opacity: 0 !important;
  }

  /* .reference:before {
content: " ";
position: absolute;
top: 100%;
left: 43px;
width: 0;
height: 0;
border-left: 10px solid transparent;
border-top: 10px solid #288CFA;
border-right: 10px solid transparent;

}
.reference:after {
content: " ";
position: absolute;
top: 100%;
left: 46px;
width: 0;
height: 0;
border-left: 7px solid transparent;
border-top: 7px solid #fff;
border-right: 7px solid transparent;
} */
  /* 强行修改ant抽屉样式 */
.ant-drawer-header {
  border-bottom: 0px solid #e8e8e8 !important;
}
 .main >>> .ant-drawer-content-wrapper {
    height: 421px;
  }
 .drawer >>> .ant-drawer-wrapper-body {
    overflow: hidden !important;
  }
 .ant-drawer-body {
    margin: 0 50px;
    display: flex !important;
    justify-content: space-between;
    padding-bottom: 0;
  }
 .main >>> .ant-drawer-content {
    /* height: 401px; */
    background: #FFFFFF;
    box-shadow: 0px -2px 6px 4px rgba(202, 202, 202, 0.5);
    border-radius: 58px 58px 0px 0px;
    border: 1px solid #E5E5E5;
  }
  /* .ant-drawer-title {
    text-align: center;
} */
 .foote {
  width: 100%;
  height: 421px;
}
 .foot_top {
  width: 99%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: #FFFFFF;
  box-shadow: 0px -2px 6px 4px rgba(202, 202, 202, 0.5);
  border-radius: 58px 58px 0px 0px;
  border: 1px solid #E5E5E5;
  cursor: pointer;
  z-index: 99;
  position: absolute;
bottom: 0;
}
 .foot_bom {
  width: 100%;
  height: 421px;

}
 .myChart1_title {
  width: 30%;
  display: flex;
  justify-content: space-between;
}
</style>
<style lang="stylus" scoped>
ul
  margin 0
  padding 0
.main
  #allmap
    width 100%
    height 85vh
    background-color #ffffff
  .modules
    .left
      position absolute
      top 0
      left 0
      li
        box-shadow 2px 2px 5px #0000003b
        height 21.5 vh
        list-style none
        background-color #fafafac2
        width 420px
        &:nth-of-type(1)
          margin 7px 0 0 0px
        &:nth-of-type(2)
           margin 7px 0 0 0px
        &:nth-of-type(3)
          margin 7px 0 0 0px
        &:nth-of-type(4)
          margin 7px 0 0 0px
    .right
      position absolute
      right 0
      top 0
      li
        box-shadow 2px 2px 5px #0000003b
        height 21.5 vh
        list-style none
        background-color #fafafac2
        width 420px
        &:nth-of-type(1)
          margin 7px 0 0 0px
        &:nth-of-type(2)
           margin 7px 0 0 0px
        &:nth-of-type(3)
          margin 7px 0 0 0px
        &:nth-of-type(4)
          margin 7px 0 0 0px
    .middle
      box-shadow 2px 2px 5px #0000003b
      position absolute
      bottom 0
      left 50%
      transform translate(-50%)
      background-color #fafafac2
      width calc(100% - 860px)
      margin 0 auto
      text-align center
      height 21.5vh

</style>
